var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{staticClass:"box"},[_c('div',{staticClass:"images"},[_c('img',{staticClass:"img",attrs:{"src":_vm.url}})])]):_c('Loading',{attrs:{"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }